import React from 'react';
import ReportingMarketingEventHealthPage from '../components/ReportingMarketingEventHealthPage';

const ReportingMarketingEventHealthApp = (props) => (
  <ReportingMarketingEventHealthPage {...props} />
);

export default ReportingMarketingEventHealthApp;
